import { render, staticRenderFns } from "./AuthenPopup.vue?vue&type=template&id=505995c6&scoped=true"
import script from "./AuthenPopup.vue?vue&type=script&lang=js"
export * from "./AuthenPopup.vue?vue&type=script&lang=js"
import style0 from "./AuthenPopup.vue?vue&type=style&index=0&id=505995c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505995c6",
  null
  
)

export default component.exports